// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLERS_NOT_APPROVED = "\u010dek\u00e1 na kontrolu";
